import { faCirclePlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FieldArray, FormikProps, getIn, useFormikContext } from "formik";
import React from "react";
import { Button, Card, Col, Row } from "react-bootstrap";

import { IGivenOnRentProperties } from "../../../../config/interfaces";
import FASvgIcon from "../../../FASvgIcon";
import { NumericInputField, TextInputField } from "../../../fields";
import PreventEditComponent from "../../../PreventEditComponent";

const RITenantDetailsForm: React.FC = () => {
  const { values } = useFormikContext<IGivenOnRentProperties>();

  return (
    <section className="mb-5">
      <Card className="more-info-card shadow-none">
        <Card.Header>
          <Card.Title>Tenant Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <section>
            <div className="section-title-wrap">
              <h5>
                <small>
                  TAN is mandatory when TDS credit is claimed u/s 194-I, PAN is mandatory when TDS
                  credit is claimed u/s 194-IB
                </small>
              </h5>
            </div>
            <FieldArray name="TenantDetails">
              {({ push, remove, form }) => (
                <>
                  {values?.TenantDetails?.map((_, index) => (
                    <section className="mb-3 mb-sm-0" key={`owner-${index}`}>
                      <TenantForm
                        index={index}
                        form={form}
                        onRemove={(itemIdx) => remove(itemIdx)}
                      />
                    </section>
                  ))}
                  <PreventEditComponent>
                    <Button
                      variant="link"
                      className="btn-add-link"
                      onClick={() =>
                        push({
                          Aadhaar: "",
                          TenantName: "",
                          Pan: ""
                        })
                      }
                    >
                      <FASvgIcon icon={faCirclePlus} />
                      Add more
                    </Button>
                  </PreventEditComponent>
                </>
              )}
            </FieldArray>
          </section>
        </Card.Body>
      </Card>
    </section>
  );
};

export default RITenantDetailsForm;

type Props = {
  index: number;
  form: FormikProps<IGivenOnRentProperties>;
  onRemove: (itemIdx: number) => void;
};

const TenantForm: React.FC<Props> = (props: Props) => {
  const { index, onRemove, form } = props;

  const { setFieldValue, handleBlur, values, touched, errors } = form;

  return (
		<>
			<Row className="align-items-center">
				<Col sm>
					<TextInputField
						label="Name of the Tenant"
						name={`TenantDetails.${index}.TenantName`}
						value={values.TenantDetails[index].TenantName || ""}
						isRequired={true}
						onBlur={(e) => {
							handleBlur(e);
							setFieldValue(
								`TenantDetails.${index}.TenantName`,
								values.TenantDetails[index].TenantName?.trim()
							);
						}}
						onChange={(value) => setFieldValue(`TenantDetails.${index}.TenantName`, value)}
						isInvalid={
							Boolean(getIn(errors, `TenantDetails.${index}.TenantName`)) &&
							getIn(touched, `TenantDetails.${index}.TenantName`)
						}
						errorMsg={getIn(errors, `TenantDetails.${index}.TenantName`)}
					/>
				</Col>
				<Col sm>
					<TextInputField
						label="PAN of the Tenant"
						name={`TenantDetails.${index}.Pan`}
						maxLength={10}
						value={values.TenantDetails[index].Pan}
						isRequired={true}
						onBlur={(e) => {
							handleBlur(e);
						}}
						onChange={(value) => setFieldValue(`TenantDetails.${index}.Pan`, value.toUpperCase())}
						isInvalid={
							Boolean(getIn(errors, `TenantDetails.${index}.Pan`)) &&
							getIn(touched, `TenantDetails.${index}.Pan`)
						}
						errorMsg={getIn(errors, `TenantDetails.${index}.Pan`)}
					/>
				</Col>
				<Col sm>
					<NumericInputField
						label="Aadhaar number of the Tenant"
						name={`TenantDetails.${index}.Aadhaar`}
						value={values.TenantDetails[index].Aadhaar}
						onBlur={handleBlur(`TenantDetails.${index}.Aadhaar`)}
						onChange={(value) => {
							setFieldValue(`TenantDetails.${index}.Aadhaar`, value);
						}}
						isInvalid={
							Boolean(getIn(errors, `TenantDetails.${index}.Aadhaar`)) &&
							getIn(touched, `TenantDetails.${index}.Aadhaar`)
						}
						errorMsg={getIn(errors, `TenantDetails.${index}.Aadhaar`)}
						separator=""
					/>
				</Col>
				<PreventEditComponent>
					<Col sm={"auto"} className="ps-0">
						<Button
							variant="transparent"
							className="text-greyDark icon-only d-none d-sm-flex"
							onClick={() => onRemove(index)}
						>
							<FASvgIcon icon={faTrash} />
						</Button>
						<Button
							variant="transparent"
							className="btn-delete-full d-sm-none"
							onClick={() => onRemove(index)}
						>
							<FASvgIcon icon={faTrash} />
							<span>Delete</span>
						</Button>
					</Col>
				</PreventEditComponent>
			</Row>
			{index !== values.TenantDetails.length - 1 && <hr className="d-block d-sm-none my-4" />}
		</>
	);
};
